import { reactive } from "vue";

// Drives the global provider-picker modal (SignInModal.vue, mounted once in
// App.vue). A store rather than component state so authUtils.startAuth() can
// open it without any CTA call site knowing the modal exists.
export const signInModal = reactive({
  isOpen: false,
  open() {
    this.isOpen = true;
  },
  close() {
    this.isOpen = false;
  },
});
